export enum LibraryItemTypeEnum {
  ContentTemplate = 'ContentTemplate',
  Media = 'Media',
  Block = 'Block',
  Metatag = 'Metatag',
  DatasetSchema = 'DatasetSchema',
  Webhook = 'Webhook',
}
